import { render, staticRenderFns } from "./SocialCampaignDialog.vue?vue&type=template&id=05bed09c&scoped=true&"
import script from "./SocialCampaignDialog.vue?vue&type=script&lang=js&"
export * from "./SocialCampaignDialog.vue?vue&type=script&lang=js&"
import style0 from "./SocialCampaignDialog.vue?vue&type=style&index=0&id=05bed09c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bed09c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05bed09c')) {
      api.createRecord('05bed09c', component.options)
    } else {
      api.reload('05bed09c', component.options)
    }
    module.hot.accept("./SocialCampaignDialog.vue?vue&type=template&id=05bed09c&scoped=true&", function () {
      api.rerender('05bed09c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/SocialCampaignDialog.vue"
export default component.exports